import i from "styled-components";
import n from "../../utils/colors.js";
import { device as e } from "../../utils/device.js";
const t = i.div`
  min-height: 160px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  flex-wrap: wrap;

  @media ${e.isTablet} {
    flex-direction: row;
    padding: 0 60px;
    justify-content: center;
  }

  @media ${e.isDesktop} {
    flex-direction: row;
    padding: 0 32px;
  }
`, l = {
  LeftAligned: i(t)`
    @media ${e.isDesktop} {
      justify-content: flex-start;
    }
  `,
  JustifyAligned: i(t)`
    @media ${e.isDesktop} {
      justify-content: space-between;
    }
  `
}, d = i.div`
  border-bottom: 1px solid ${n.darkGrey10};
  width: 100%;
  height: 0;
  padding: 0;
  margin: 0;
  flex-basis: 100%;

  @media ${e.isDesktop} {
    display: none;
    flex-basis: 0;
  }
`, o = i.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 21px;

  @media ${e.isDesktop} {
    justify-content: flex-end;
    order: 3;
    padding: 0;
  }

  @media ${e.isTablet} {
    padding: 30px;
  }

  @media ${e.isMobile} {
    order: 0;
  }
`, p = i(o)`
  flex: 1;
`, m = i.div`
  display: flex;
  flex-direction: column;
  margin: 30px;
  order: 1;

  @media ${e.isTablet} {
    flex: 1;
  }

  @media ${e.isTablet}, ${e.isDesktop} {
    align-self: flex-start;
  }
`, c = i.div`
  display: flex;
  flex-direction: column;
  order: 2;
  margin: 30px;

  @media ${e.isMobile} {
    margin-top: 0;
  }

  @media ${e.isTablet} {
    flex: 1;
  }

  @media ${e.isTablet}, ${e.isDesktop} {
    align-self: flex-start;
  }
`, x = i.div`
  display: flex;
  flex-direction: column;

  > div {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`, f = i.div`
  font-family: VIC;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: -0.28px;
  text-align: center;
  margin-bottom: 16px;
  min-height: 22px;
`, g = i.div`
  margin: 0 auto;
  img {
    max-width: 200px;
    height: auto;
  }
`;
export {
  o as ActionsContainer,
  x as AgenciesGroup,
  f as AgenciesTitle,
  g as AgencyLogo,
  d as Divider,
  p as FillActionsContainer,
  c as PartnerAgenciesContainer,
  m as ProgramAgencyContainer,
  l as Wrapper
};
